import * as R from 'ramda';
import Checkbox from 'rc-checkbox';
import React from 'react';
import { connect } from 'react-redux';
import useObjectiveCategories from './objectiveCategories/useObjectiveCategories';
import getAmendmentInfos from '../../../../lib/getAmendmentInfos';

const ObjectiveCategories = ({
  college,
  offerType,
  ccn,
  collegeIsSelected,
  selectedCategories,
  setSelectedCategories,
  courseIsAmendment,
  isKnownAmendment
}) => {
  const {
    displayObjectiveCategoriesSelection,
    objectiveCategories,
    objectiveCategoryIsSelected,
    updateObjectiveCategory
  } = useObjectiveCategories({
    college,
    offerType,
    ccn,
    collegeIsSelected,
    selectedCategories,
    setSelectedCategories,
    courseIsAmendment,
    isKnownAmendment
  });

  if (!displayObjectiveCategoriesSelection) {
    return null;
  }

  return <div className="flex flex-col gap-y-4 my-4 ml-8 text-xs">
    {R.map(objectiveCategory => {
      const { option, label } = objectiveCategory;

      return <div
        key={`objectiveCategory-${college}-${option}`}
        className="flex items-start gap-x-4"
      >
        <Checkbox
          checked={objectiveCategoryIsSelected(objectiveCategory)}
          onChange={() => updateObjectiveCategory(objectiveCategory)}
        />

        <div>{label}</div>
      </div>;
    })(objectiveCategories)}
  </div>;
};

export default connect(
  ({ proposition }) => {
    return {
      ccn: R.path(['data', 'ccn'], proposition),
      offerType: R.pathOr('PREVOYANCE', ['data', 'currentOfferType'])(proposition),
      ...getAmendmentInfos(proposition.data)
    };
  }
)(ObjectiveCategories);
